import { Autocomplete, FormLayout, Select, TextField } from '@shopify/polaris';
import React, { useEffect, useState } from 'react'
import { DI, DIProps } from '../../../../Core';
interface SelectOptI { label: string, value: string, data: any }
interface PropsI extends DIProps {
    textFieldValue: { name: string, email: string, phone: string, address_line_1: string, address_line_2: string, country: string, state: string, city: string, zip: string, tag: string, error: boolean, from_warehouse: boolean };
    onChange: (value: string, id: string) => void
}
const CountrySelection = (props: PropsI) => {
    const { textFieldValue, onChange } = props

    const [loader, setLoader] = useState(false);
    const [options, setOptions] = useState<{ countries: SelectOptI[], states: SelectOptI[], cities: SelectOptI[] }>({
        countries: [],
        states: [],
        cities: []
    });

    const [matchedOptions, setMatchedOptions] = useState<{ states: SelectOptI[], cities: SelectOptI[] }>({
        states: [],
        cities: []
    });

    const getDetails = (key: 'country' | 'state' | '', payload: { country_name: string; _id: string, state_name?: string, state_id?: string } | {}) => {
        setLoader(true);
        props.di.GET('frontend/country/getDetails', payload).then((res: any) => {
            setLoader(false)
            if (res?.success) {
                if (!key) {
                    let countries: SelectOptI[] = res?.data.map((country: any) => {
                        if (['FR', 'IN', 'IT', 'ES', 'GB', 'US'].includes(country?.iso2 ?? '')) {
                            return {
                                label: `${country.name} (${country.iso2})`,
                                value: country.iso2,
                                data: country
                            }
                        }
                    }).filter((a: any) => a)
                    setOptions(a => ({ ...a, countries: countries }))
                }
                if (key === 'country') {
                    let states: SelectOptI[] = res?.data.map((state: any) => {
                        if (!state?.name) return;
                        return {
                            label: state.name,
                            value: state.name,
                            data: state
                        }
                    }).filter((a: any) => a)
                    setOptions(a => ({ ...a, states: states }))
                    setMatchedOptions(a => ({
                        ...a,
                        states: states.filter((option) =>
                            option.label.match(new RegExp(textFieldValue.state, 'i')),
                        )
                    }))
                }
                if (key === 'state') {
                    let cities: SelectOptI[] = res?.data.map((city: any) => {
                        if (!city?.name) return;
                        return {
                            label: city.name,
                            value: city.name,
                            data: city
                        }
                    }).filter((a: any) => a)
                    setOptions(a => ({ ...a, cities: cities }))
                    setMatchedOptions(a => ({
                        ...a,
                        cities: cities.filter((option) =>
                            option.label.match(new RegExp(textFieldValue.city, 'i')),
                        )
                    }))
                }
            }
            else {
                props.error(res?.message)
            }
        })
    }

    useEffect(() => {
        if (!textFieldValue.country) return;
        let country = options.countries.find(a => a.value === textFieldValue.country)?.data
        if (!!country?.name && !!country?._id?.$oid)
            getDetails('country', {
                country_name: country.name,
                _id: country._id.$oid
            })
    }, [textFieldValue.country])

    useEffect(() => {
        if (!textFieldValue.state) return;
        let country = options.countries.find(a => a.value === textFieldValue.country)?.data
        let state = options.states.find(a => a.value === textFieldValue.state)?.data
        if (!!country?.name && !!country?._id?.$oid && !!state?.name && !!state?.state_id) {
            getDetails('state', {
                country_name: country.name,
                _id: country._id.$oid,
                state_name: state.name,
                state_id: state.state_id
            })
        }
    }, [textFieldValue.state])

    useEffect(() => {
        getDetails('', {})
    }, [])

    return <>
        <FormLayout>
            <FormLayout.Group condensed>
                <Select
                    options={options.countries}
                    label='Country'
                    requiredIndicator
                    id='country'
                    value={textFieldValue.country} onChange={onChange}
                    error={textFieldValue.error && !textFieldValue.country}
                    disabled={loader}
                    placeholder='Select Country'
                />
                <Autocomplete
                    textField={
                        <Autocomplete.TextField
                            label="State" id='state'
                            value={textFieldValue.state} type="text"
                            onChange={(value) => {
                                setMatchedOptions(a => ({
                                    ...a,
                                    states: options.states.filter((option) =>
                                        option.label.match(new RegExp(value, 'i')),
                                    )
                                }))
                                onChange(value, 'state')
                            }} autoComplete="off"
                            disabled={loader}
                        />}
                    onSelect={(selected) => {
                        setMatchedOptions(a => ({
                            ...a,
                            states: options.states.filter((option) =>
                                option.label.match(new RegExp(selected[0], 'i')),
                            )
                        }));
                        onChange(selected[0], 'state');
                    }}
                    selected={[textFieldValue.state]}
                    options={matchedOptions.states}
                />
                <Autocomplete
                    textField={
                        <Autocomplete.TextField
                            label="City" id='city'
                            value={textFieldValue.city} type="text"
                            onChange={(value) => {
                                setMatchedOptions(a => ({
                                    ...a,
                                    cities: options.cities.filter((option) =>
                                        option.label.match(new RegExp(value, 'i')),
                                    )
                                }))
                                onChange(value, 'city')
                            }} autoComplete="off"
                            error={textFieldValue.error && !textFieldValue.city}
                            disabled={loader}
                            requiredIndicator />
                    }
                    onSelect={(selected) => {
                        setMatchedOptions(a => ({
                            ...a,
                            cities: options.cities.filter((option) =>
                                option.label.match(new RegExp(selected[0], 'i')),
                            )
                        }));
                        onChange(selected[0], 'city')
                    }}
                    selected={[textFieldValue.city]}
                    options={matchedOptions.cities}
                />
                <TextField label="Postal Code" id='zip' value={textFieldValue.zip} onChange={(value: string, id: string) => {
                    value = value.replace(/[!$%^&*()@_+|~=`\\#{}\[\]:"`;'<>?,\/]/gi, '');
                    onChange(value, id);
                }} autoComplete="off" error={textFieldValue.error && !textFieldValue.zip} requiredIndicator maxLength={11} />
            </FormLayout.Group>
        </FormLayout>
    </>;
}

export default DI(CountrySelection)
